import { Button } from '@shared/components/ui/button'
import { Home, Star, CircleUserRound, LogIn } from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@shared/contexts'
import { toast } from 'sonner'
import { useState } from 'react'
import { PWAInstallDrawer } from './PWAInstallDrawer'

export function NavBar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated, authConfirmed } = useAuth()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  // Show "Perfil" only once the session is genuinely confirmed. Until then
  // (or if confirmation says it's dead), default to logged-out — never flash
  // "Perfil" on a stale localStorage guess.
  const showAsAuthenticated = authConfirmed && isAuthenticated

  // Active state detection
  const isHomeActive = location.pathname === '/'
  const isProfileActive = ['/profile', '/login'].includes(location.pathname)

  // Handler for home button - clear history by using replace
  const handleHomeClick = () => {
    void navigate('/', { replace: true })
  }

  // Handler for disabled Favoritos tab
  const handleFavoritosClick = () => {
    toast.info('Próximamente: Guarda tus profesionales favoritos', {
      duration: 3000,
    })
  }

  // Profile/Login handler
  const handleProfileClick = () => {
    void navigate(showAsAuthenticated ? '/profile' : '/login')
  }

  return (
    <>
      {/* PWA Install Drawer with Handle */}
      <PWAInstallDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onToggle={() => setIsDrawerOpen(!isDrawerOpen)}
      />

      <nav
        className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background"
        role="navigation"
        aria-label="Navegación principal"
        data-tour="navbar"
      >

        <div className="flex h-14 items-stretch">
          {/* Inicio Tab */}
          <Button
            variant="navTab"
            size="navTab"
            className="flex-1"
            onClick={handleHomeClick}
            aria-current={isHomeActive ? 'page' : undefined}
            data-active={isHomeActive}
          >
            <Home size={24} />
            <span className="text-xs">Inicio</span>
          </Button>

          {/* Favoritos Tab (Disabled) */}
          <Button
            variant="navTab"
            size="navTab"
            className="flex-1"
            onClick={handleFavoritosClick}
            aria-disabled="true"
            aria-label="Favoritos - Próximamente"
          >
            <Star size={24} />
            <span className="text-xs">Favoritos</span>
          </Button>

          {/* Perfil/Login Tab */}
          <Button
            variant="navTab"
            size="navTab"
            className="flex-1"
            onClick={handleProfileClick}
            aria-current={isProfileActive ? 'page' : undefined}
            data-active={isProfileActive}
            aria-label={showAsAuthenticated ? 'Mi perfil' : 'Iniciar sesión'}
            data-tour="navbar-profile"
          >
            {showAsAuthenticated ? <CircleUserRound size={24} /> : <LogIn size={24} />}
            <span className="text-xs">{showAsAuthenticated ? 'Perfil' : 'Ingresar'}</span>
          </Button>
        </div>

        {/* Version Number */}
        <div className="absolute right-2 bottom-1 text-xs text-primary-foreground">
          v{__APP_VERSION__}
        </div>
      </nav>
    </>
  )
}
